import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const env = process.env.NODE_ENV
const base = env === 'test' ? '' : ''
const router = new Router({
    mode: 'history',
    base: base,
    routes: [
        {path: '/', redirect: '/index'},
        {
            path: '/index', meta: {title: '首页', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/Index'), 'index'))
        },

        // user 用户相关
        {
            path: '/company_auth', meta: {title: '企业认证'},
            component: r => require.ensure([], () => r(require('@/views/user/CompanyAuth'), 'company_auth'))
        }, {
            path: '/login', meta: {title: '登录'},
            component: r => require.ensure([], () => r(require('@/views/user/Login'), 'login'))
        }, {
            path: '/register', meta: {title: '注册'},
            component: r => require.ensure([], () => r(require('@/views/user/Register'), 'register'))
        }, {
            path: '/register_success', meta: {title: '注册成功'},
            component: r => require.ensure([], () => r(require('@/views/user/RegisterSucc'), 'register'))
        }, {
            path: '/pwd_reset', meta: {title: '修改密码'},
            component: r => require.ensure([], () => r(require('@/views/user/PwdReset'), 'pwd'))
        }, {
            path: '/pwd_reset_success', meta: {title: '修改密码成功'},
            component: r => require.ensure([], () => r(require('@/views/user/PwdResetSucc'), 'pwd'))
        }, {
            path: '/auth_success', meta: {title: '认证提交成功'},
            component: r => require.ensure([], () => r(require('@/views/user/AuthSuccess'), 'auth'))
        },

        // member 会员中心
        {
            path: '/member/',
            component: r => require.ensure([], () => r(require('@/views/member/Default'), 'member')),
            redirect: '/member/index',
            children: [
                {
                    path: 'index', meta: {title: '会员中心'},
                    component: r => require.ensure([], () => r(require('@/views/member/Index'), 'member'))
                }, {
                    path: 'order', meta: {title: '内存测试订单'},
                    component: r => require.ensure([], () => r(require('@/views/member/Order'), 'member'))
                }, {
                    path: 'info', meta: {title: '账户信息'},
                    component: r => require.ensure([], () => r(require('@/views/member/Information'), 'member'))
                }, {
                    path: 'info/mobile/step1', mate: {title: '修改手机号'},
                    component: r => require.ensure([], () => r(require('@/views/member/mobile/AlterMobile1'), 'member'))
                }, {
                    path: 'info/mobile/step2', meta: {title: '修改手机号'},
                    component: r => require.ensure([], () => r(require('@/views/member/mobile/AlterMobile2'), 'member'))
                }, {
                    path: 'info/mobile/success', meta: {title: '修改手机号'},
                    component: r => require.ensure([], () => r(require('@/views/member/mobile/AlterMobileSucc'), 'member'))
                }, {
                    path: 'alter_pwd', meta: {title: '修改密码'},
                    component: r => require.ensure([], () => r(require('@/views/member/pwd/AlterPwd'), 'member'))
                }, {
                    path: 'addr_info', meta: {title: '收/取货信息'},
                    component: r => require.ensure([], () => r(require('@/views/member/AddrInfo'), 'member'))
                }, {
                    path: 'wallet', meta: {title: '钱包账户管理'},
                    component: r => require.ensure([], () => r(require('@/views/member/wallet/Wallet'), 'member'))
                }, {
                    path: 'wallet/step1', meta: {title: '钱包账户管理-开通'},
                    component: r => require.ensure([], () => r(require('@/views/member/wallet/Open1'), 'member'))
                }, {
                    path: 'wallet/step2', meta: {title: '钱包账户管理-开通'},
                    component: r => require.ensure([], () => r(require('@/views/member/wallet/Open2'), 'member'))
                }, {
                    path: 'wallet/step3', meta: {title: '钱包账户管理-开通'},
                    component: r => require.ensure([], () => r(require('@/views/member/wallet/Open3'), 'member'))
                }, {
                    path: 'wallet/success', meta: {title: '钱包账户管理-开通'},
                    component: r => require.ensure([], () => r(require('@/views/member/wallet/OpenSucc'), 'member'))
                }, {
                    path: 'wallet/withdraw1', meta: {title: '钱包账户管理-提现'},
                    component: r => require.ensure([], () => r(require('@/views/member/withdraw/Withdraw1'), 'member'))
                }, {
                    path: 'wallet/withdraw2', meta: {title: '钱包账户管理-提现'},
                    component: r => require.ensure([], () => r(require('@/views/member/withdraw/Withdraw2'), 'member'))
                }, {
                    path: 'wallet/withdraw3', meta: {title: '钱包账户管理-提现'},
                    component: r => require.ensure([], () => r(require('@/views/member/withdraw/WithdrawSucc'), 'member'))
                }, {
                    path: 'recharge', meta: {title: '钱包账户管理-充值'},
                    component: r => require.ensure([], () => r(require('@/views/member/recharge/Recharge'), 'member'))
                }, {
                    path: 'recharge/success', meta: {title: '钱包账户管理-充值'},
                    component: r => require.ensure([], () => r(require('@/views/member/recharge/RechargeSucc'), 'member'))
                }, {
                    path: 'wallet/alter_account_success', meta: {title: '钱包账户管理-修改提现账户'},
                    component: r => require.ensure([], () => r(require('@/views/member/wallet/AlterAccountSucc'), 'member'))
                }, {
                    path: 'pwd', meta: {title: '支付密码管理'},
                    component: r => require.ensure([], () => r(require('@/views/member/pwd/Pwd'), 'member'))
                }, {
                    path: 'pwd/alter1', meta: {title: '支付密码管理-修改支付密码'},
                    component: r => require.ensure([], () => r(require('@/views/member/pwd/PwdAlter1'), 'member'))
                }, {
                    path: 'pwd/alter2', meta: {title: '支付密码管理-修改支付密码'},
                    component: r => require.ensure([], () => r(require('@/views/member/pwd/PwdAlter2'), 'member'))
                }, {
                    path: 'pwd/reset', meta: {title: '支付密码管理-重置支付密码'},
                    component: r => require.ensure([], () => r(require('@/views/member/pwd/PwdReset'), 'member'))
                }, {
                    path: 'pwd/success', meta: {title: '支付密码管理-修改成功'},
                    component: r => require.ensure([], () => r(require('@/views/member/pwd/PwdSucc'), 'member'))
                }, {
                    path: 'record', meta: {title: '钱包明细记录-充值记录'},
                    component: r => require.ensure([], () => r(require('@/views/member/recharge/RechargeRecord'), 'member'))
                }, {
                    path: 'news', meta: {title: '我的消息'},
                    component: r => require.ensure([], () => r(require('@/views/member/News'), 'member'))
                }, {
                    path: 'announce', meta: {title: '领存公告'},
                    component: r => require.ensure([], () => r(require('@/views/member/Announce'), 'member'))
                }
            ]
        },
        //领存测试
        {
            path: '/test', meta: {title: '领存测试', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/test/Test'), 'test')),
            redirect: "/test/index",
            children: [
                {
                    path: '/test/index', meta: {title: '预约测试', noAuth: true},
                    component: r => require.ensure([], () => r(require('../views/test/Index'), 'test'))
                }, {
                    path: '/test/online_test1', meta: {title: '提交测试信息'},
                    component: r => require.ensure([], () => r(require('../views/test/OnlineTest1'), 'test'))
                }, {
                    path: '/test/online_test2', meta: {title: '获取报价预约排期'},
                    component: r => require.ensure([], () => r(require('../views/test/OnlineTest2'), 'test'))
                }, {
                    path: '/test/online_test3', meta: {title: '支付订单金额'},
                    component: r => require.ensure([], () => r(require('../views/test/OnlineTest3'), 'test'))
                }, {
                    path: '/test/online_test4', meta: {title: '按指定时间地点送测'},
                    component: r => require.ensure([], () => r(require('../views/test/OnlineTest4'), 'test'))
                }, {
                    path: '/test/online_test5', meta: {title: '查询进度下载报告'},
                    component: r => require.ensure([], () => r(require('../views/test/OnlineTest5'), 'test'))
                },
            ]
        },
        // 帮助中心
        {
            path: '/help', meta: {title: '帮助中心'},
            component: r => require.ensure([], () => r(require('@/views/Help'), 'help'))
        },
        // error page
        {
            path: '/404', meta: {title: '404', noAuth: true},
            component: r => require.ensure([], () => r(require('@/views/error/404'), 'error'))
        },
        {path: '*', redirect: "/404"},
    ]
})
router.beforeEach((to, from, next) => {
    // console.log(to)
    document.title = to.meta.title ? '领存测试-' + to.meta.title : '深圳市领存技术有限公司'
    if (to.matched.some(r => r.meta.requireAuth)) {
        if (store.state.token) {
            next()
        }
        // 这段代码总是跳登录页
        // else {
        //     if(to.fullPath == '/pwd_reset' || to.fullPath == '/register_success' || to.fullPath == '/pwd_reset_success' || to.fullPath == '/pwd_reset_success') {
        //         next({
        //             path: '/login'
        //         })
        //     } else {
        //         next({
        //             path: '/login',
        //             query: {redirect: to.fullPath}
        //         })
        //     }
        // }
    }
    else {
        next()
    }
})
// 跳转后返回顶部
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js